import React from 'react';
import {Link} from "react-router-dom";

import {RtBreadCrumb} from '../../../server/routes/route-types.js'

interface BreadCrumbsProps {
    BreadCrumbs: RtBreadCrumb[];
}

interface ComponentProps {
    props?: BreadCrumbsProps;
}

export default function BreadCrumbs({props}: ComponentProps) {

	if (!props || !props.BreadCrumbs)	return null;

	return (

	<section>
		<div className="container">
			<nav aria-label="breadcrumb">
				<ol className="breadcrumb" style={{backgroundColor:'white'}}>
					{
						props.BreadCrumbs.map((crumb, indexKey) => {
							if (crumb.Current) {
								return (
									<li className="breadcrumb-item active" aria-current="page"  key={indexKey}>{crumb.Text}</li>
								)
							}
							else {
								return (
									
										crumb.URL=="/" ?
										<li className="breadcrumb-item"  key={indexKey}>
											<Link                                  
												className="brand" 
												to="/"
											>
												{crumb.Text}
											</Link>
										</li>
										:
										<li className="breadcrumb-item"  key={indexKey}>
										<Link 
												to={crumb.URL}
											>
												{crumb.Text}
											</Link>											
										</li>
									
								)
							}
						})
					}
				</ol>
			</nav>
		</div>
	</section>
	) 

}
